type SaveExperimentRegistration = {
  open: () => void
  disabled: boolean
  tooltip?: string
} | null

let registration: SaveExperimentRegistration = null

const listeners = new Set<() => void>()

export function setSaveExperimentRegistration(next: SaveExperimentRegistration): void {
  registration = next
  listeners.forEach(listener => listener())
}

export function getSaveExperimentRegistration(): SaveExperimentRegistration {
  return registration
}

export function subscribeSaveExperimentRegistration(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
